export const setLocalStorage = (itemName :string, itemValue:string) => {
  localStorage.setItem(itemName, itemValue);
};

export const getFromLocalStorage = (itemName:string) => localStorage.getItem(itemName);
